import React, { useState } from 'react'
import clsx from 'clsx'
import { MenuFilterProps } from '@/components/organisms/VideoLibrarySection/types'

export default function MenuFilterMobile({
  menuItems,
  setCategory,
  category,
  allVideosLabel,
  featuredLabel,
  categoriesLabel
}: MenuFilterProps) {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = (item: string) => {
    setCategory(item)
    setIsOpen(!isOpen)
  }

  return (
    <div>
      <div className="w-full flex flex-col gap-24 rounded p-12 text-bodyM text-text-dark-900 border-1 border-grey-100 overflow-hidden">
        <div
          className="w-full netbook:w-208 flex justify-between items-center text-text-dark-900 font-bold cursor-pointer z-10"
          onClick={() => setIsOpen(!isOpen)}
        >
          {category}
          <i
            className={clsx(isOpen && '-rotate-180', 'fa fa-chevron-down ml-auto netbook:ml-8 duration-300')}
            aria-hidden="true"
          />
        </div>
        {isOpen && (
          <>
            <div className="flex gap-12 items-center " onClick={() => handleClick(allVideosLabel)}>
              <input
                readOnly
                type="radio"
                name="categories"
                id="all_videos"
                value={allVideosLabel}
                className="cursor-pointer appearance-none "
              />
              <label className="cursor-pointer w-full" htmlFor="all_videos">
                {allVideosLabel}
              </label>
            </div>
            <div className="flex gap-12 items-center" onClick={() => handleClick(featuredLabel)}>
              <input
                readOnly
                type="radio"
                name="categories"
                id="featured"
                value={featuredLabel}
                className="cursor-pointer appearance-none"
              />
              <label className="cursor-pointer w-full" htmlFor="featured">
                {featuredLabel}
              </label>
            </div>
            <div>
              <p className="font-poppins leading-30 tracking-wide text-bodyL uppercase font-bold mb-16 text-primary-600">
                {categoriesLabel}
              </p>
              <div className="flex flex-col gap-16">
                {menuItems.map((item) => (
                  <div className="flex gap-12 items-center" key={item} onClick={() => handleClick(item)}>
                    <input
                      readOnly
                      checked={category === item}
                      type="radio"
                      name="categories"
                      id={item}
                      value={item}
                      className="cursor-pointer appearance-none bg-white border-1 border-solid rounded-full w-24 h-24 text-grey-100 checked:bg-primary-500 checked:ring-4 checked:ring-white checked:text-primary-500 checked:ring-inset"
                    />
                    <label className="cursor-pointer" htmlFor={item}>
                      {item}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
